import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  Inject,
} from '@angular/core';
import { FormGroup, FormGroupDirective } from '@angular/forms';
import { ConfirmDialogComponent } from 'src/app/shared-layout/Components/confirm-dialog/confirm-dialog.component';
import { LANGUAGE_CONSTANTS as LANG_CONST } from 'src/app/shared/constants/language-constants';
import { CommonService } from 'src/app/shared/utils/common.service';
import { HelperService } from 'src/app/shared/utils/helper.service';
import { CONSTANTS } from 'src/app/shared/constants/constants';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { LocalizationService } from 'src/app/shared/services/localization.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-lock-info',
  templateUrl: './lock-info.component.html',
  styleUrls: ['./lock-info.component.scss'],
})
export class LockInfoComponent implements OnInit {
  @Input() formGroupName!: string;
  formGroup!: FormGroup;
  @Input() dialogRef?: any; //close event of parent component
  @Input() stepper!: number;
  @Output() stepperChange = new EventEmitter<number>();
  submited = false;
  orignalFormData: string | undefined;

  readonly LANG_CONST = LANG_CONST;
  CONSTANTS = CONSTANTS;

  /**
   * @description control getter formgroup
   * @returns rective controls
   */
  get formInstance() {
    return this.formGroup.controls;
  }

  constructor(
    private rootFormGroup: FormGroupDirective,
    public commonService: CommonService,
    private helperService: HelperService,
    private localizationService: LocalizationService,
    @Inject(MAT_DIALOG_DATA) private modalData: any,
    private translate: TranslateService
  ) {}

  /**
   * @description this is onInit life cycle method
   *  get formgroup from parent rootgroup
   * initialise weekly list
   */
  ngOnInit(): void {
    this.localizationService.setupLocalization();
    this.formGroup = this.rootFormGroup.control.get(
      this.formGroupName
    ) as FormGroup;
    // in case form state create mode
    if (!this.modalData.isEditable)
      this.orignalFormData = JSON.stringify(this.formGroup.value);
  }

  /**
   * @description close modal by the help of dialgue reference
   * @returns void
   */
  closeDialog(): void {
    if (this.orignalFormData === JSON.stringify(this.formGroup.value)) {
      this.dialogRef?.close();
      return;
    }
    const dialogInstance = this.helperService.openModalDialog(
      ConfirmDialogComponent,
      {
        title: this.translate.instant('TITLE'),
        headingText: this.translate.instant('HEADING_TEXT'),
        bodyText: this.translate.instant('BODY_TEXT'),
        footerText: this.translate.instant('FOOTER_TEXT'),
      },
      CONSTANTS.FIXED_SCREEN_MODAL
    );
    dialogInstance.afterClosed().subscribe((result: boolean) => {
      if (result) {
        this.dialogRef?.close();
      }
    });
  }

  /**
   * @description navigate back button form previous step
   * @returns void
   */
  navigateBack(): void {
    this.stepperChange.emit((this.stepper += -1));
  }

  /**
   * @description validate form if form valid redirect to other stepper
   * @returns void
   */
  submit(): void {
    this.submited = true;
    if (this.formGroup.invalid) return;
    this.stepperChange.emit((this.stepper += 1));
  }

  /**
   * @description reset local variables state
   * @returns void
   */
  resetForm(): void {
    this.formGroup.reset();
  }
}
